export class HelpCenterOnboardingWidget extends HTMLElement {

	public connectedCallback(): void {
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="flex-row">
						<div class="flex-column-auto">
							<div class="panel-heading">
								<h4 class="panel-title">${messages["onboardingDashboard.helpCenter.title"]}</h4>
							</div>	
							<div class="panel-body pt-0">
								<div>
									<p style="line-height: 25px">
										${messages["onboardingDashboard.helpCenter.body"]}
									</p>
								</div>
								<div class="flex-vertical-center">
									${messages["onboardingDashboard.helpCenter.documentation"]}
								</div>
							</div>
						</div>
						<div class="flex-column justify-content-center">
							<img class="pull-right" src="/timr/images/onboarding/helpCenter.png"  alt="Help Center Illustration" height="150px"/>
						</div>
					</div>
				</div>`;
	}
}
